import {useState, useEffect, useRef} from 'react'

export function useBufferedStreaming(content: string, intervalMs: number, enabled = true) {
  const [displayedContent, setDisplayedContent] = useState(content)

  const lastContent = useRef(content)
  const buffer = useRef('')

  useEffect(() => {
    const newContent = content.indexOf(lastContent.current) === 0 ? content.slice(lastContent.current.length) : null
    lastContent.current = content

    // not streamable; just show the new content
    if (newContent === null || !enabled) {
      lastContent.current = content
      buffer.current = ''
      setDisplayedContent(content)
      return
    }

    buffer.current += newContent

    const interval = setInterval(() => {
      if (!buffer.current) {
        clearInterval(interval)
        return
      }

      // setState is async, so accessing buffer.current inside the callback could result in race conditions
      const nextChar = buffer.current[0] ?? ''
      buffer.current = buffer.current.slice(1)
      setDisplayedContent(c => c + nextChar)
    }, intervalMs)

    return () => clearInterval(interval)
  }, [content, intervalMs, enabled])

  return displayedContent
}
